import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=1e25fa3c&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=1e25fa3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e25fa3c",
  null
  
)

export default component.exports